import React, { useRef, useState, useEffect } from 'react';
import { Form, Formio } from 'react-formio';
import premium from '@formio/premium';
import sanitizeHtml from 'sanitize-html';
import CustomFileComponent from './FhirFileComponent';
import { Modal, ModalButton, ModalText } from '../Modal';

import '../../../node_modules/formiojs/dist/formio.full.min.css';
import '../../../node_modules/@formio/premium/dist/premium.css';

Formio.use(premium);

const FormContainer = ({ formJson, formTitle, baseUrl, submission, submissionWarning, onChange, onSubmit }) => {
	const formRef = useRef(null);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [submissionData, setSubmissionData] = useState({});
	const [formSubmission, setFormSubmission] = useState({});

	useEffect(() => {
		setFormSubmission(JSON.parse(JSON.stringify(submission)));
	}, [submission])

	const formChange = () => {
		const sub = formRef?.current?.formio?._submission;
		if (sub) {
			onChange(sub);
		} else {
			console.error('Error: formio._submission is null. Check FormContainer.jsx');
		}
	}

	const submitForm = (submission) => {
		setIsSubmitting(true);
		setSubmissionData(submission);
	}

	const submitClick = () => {
		setIsSubmitting(false);
		onSubmit(submissionData);
	}

	const cancelClick = () => {
		setIsSubmitting(false);
		// reset submit button
		formRef.current.formio.setAlert();
		formRef.current.formio.emit('change', { isValid: true });
	}

	return (
		<>
			<h1>{formTitle}</h1>
			<Form
				form={formJson}
				submission={formSubmission}
				onChange={formChange}
				onSubmit={submissionWarning ? submitForm : onSubmit}
				options={{
					baseUrl: baseUrl
				}}
				ref={formRef}
			/>
			{
				isSubmitting && submissionWarning &&
				<WarningModal
					modalMessage={submissionWarning}
					handleSubmitClick={submitClick}
					handleCancelClick={cancelClick}
				/>
			}
		</>
	);
};

const WarningModal = (props) => {
	return <Modal>
		<ModalText
			message={<div dangerouslySetInnerHTML={{ __html: sanitizeHtml(props.modalMessage) }}></div>}
		/>

		<ModalButton
			label="Submit"
			handleButtonClick={props.handleSubmitClick}
		/>

		<ModalButton
			label="Cancel"
			handleButtonClick={props.handleCancelClick}
		/>
	</Modal>;
}

export default FormContainer;